import React from 'react'
import MyCalendar from '../../Screens/Meetings/Meetinglist'
import Header from '../Common/Header/Header'
import Footer from '../Common/Footer/Footer'

function Meetings() {
    return (
        <div>
            <Header />
            <MyCalendar />
            <Footer />
        </div>
    )
}

export default Meetings


